// extracted by mini-css-extract-plugin
export default {"outerDiv":"RestaurantPage_outerDiv__k8U3X","innerDiv":"RestaurantPage_innerDiv__hSe25","innerDiv2":"RestaurantPage_innerDiv2__cXl85","breadcrumb":"RestaurantPage_breadcrumb__COEMI"};